/**
 * Class and methods to handle the part list cart functionality
 */

// Vendors
import $ from 'jquery';
import Cookies from 'js-cookie';

class Cart {
  constructor(element) {
    const product = $(element);
    const productId = product.data('product-id');

    this.product = product;
    this.id = productId;
    this.product_num = product.find('input[name="product_num"]').val();
    this.qty = product.find('.form__input--qty');
    this.add = product.find('[data-add]');
    this.quick_order = product.find('[data-quick-order]');
    this.tpm_sku = product.parent().find('input[name="tpm_sku"]');
    this.remove = product.find('[data-action="remove"]');
    this.updateQty = product.find('[data-action="update-qty"]');
    this.url = '/wp-admin/admin-ajax.php?action=post_ajax_cart';
    this.sku_span = product.parent().find('.product__sku');
    this.recommended_product_qty = product
      .parent()
      .find('input[name="recommended_product_qty"]');
    this.recommended_product_num = product
      .parent()
      .find('select[name="recommended_product_sku"]');
    this.setListeners();
  }

  // add all event listeners
  setListeners() {
    this.add.on('click', event => this.addToCart(event));
    this.quick_order.on('click', event => this.quickOrder(event));
    this.remove.on('click', event => this.removeFromCart(event));
    this.updateQty.on('blur', event => this.updateProductQty(event));
    this.tpm_sku.on('change', event => this.updateSku(event));
    this.recommended_product_num.on('change', event =>
      this.updateRecommendedProduct(event)
    );
  }

  // add to cart
  addToCart(event) {
    event.preventDefault();
    let qty = this.qty.val();
    this.ajaxAddToCart(
      this.id,
      qty,
      this.product_num,
      this.recommended_product_num.find(':selected').data('rp-id'),
      this.recommended_product_qty.val(),
      this.recommended_product_num.val()
    );
  }

  // quick order
  quickOrder(event) {
    event.preventDefault();
    let qty = $('.quick-order--qty');
    for (var i = 0; i < qty.length; i++) {
      let qtyVal = qty[i].value;
      if (qtyVal > 0 && qtyVal !== '') {
        let id = qty[i].dataset.quick_order_id;
        let sku = qty[i].dataset.quick_order_sku;
        this.ajaxAddToCart(id, qtyVal, sku);
      }
    }
  }

  // remove product from cart
  removeFromCart(event) {
    event.preventDefault();
    this.ajaxRemoveFromCart(this.id);
  }

  // update product quantity
  updateProductQty() {
    event.preventDefault();
    let qty = this.qty.val();
    this.ajaxUpdateCartQty(this.id, qty);
  }

  // update product sku
  updateSku(event) {
    let sku = this.product
      .parent()
      .find('input[name="tpm_sku"]:checked')
      .val();
    this.product_num = sku;
    this.product.find('input[name="product_num"]').val(sku);
    this.sku_span.text(sku);
  }

  // update product sku
  updateRecommendedProduct(event) {
    let rp_id = this.recommended_product_num.find(':selected').data('rp-id');
    let rp_info_divs = this.product.parent().find('.recommended_product_info');
    let rp_info_div_show = this.product
      .parent()
      .find('#recommended_product_info_' + rp_id);
    rp_info_divs.hide();
    rp_info_div_show.show();
  }

  // Ajax request add to cart
  ajaxAddToCart(id, qty, product_num, rec_id, rec_qty, rec_num) {
    const data = {
      action: 'post_ajax_cart',
      id: id,
      qty: qty,
      product_num: product_num,
      add_to_cart: true,
      rec_id: rec_id,
      rec_qty: rec_qty,
      rec_num: rec_num,
    };

    $.ajax({
      type: 'POST',
      url: this.url,
      dataType: 'json',
      data: data,
      beforeSend: () => {
        this.add.html('Adding Part to List...');
      },
      success: res => {
        Cookies.set('part_list', res.data.part_list, {
          expires: 365,
          path: '/',
        });
        let successUrl = '/parts-list/?added_to_cart_success';
        // Redirect to part list
        location.replace(successUrl);
      },
    });
  }

  // Ajax request to remove products from cart
  ajaxRemoveFromCart(id) {
    const data = {
      action: 'post_ajax_cart',
      id: id,
      remove_from_cart: true,
    };

    $.ajax({
      type: 'POST',
      url: this.url,
      dataType: 'json',
      data: data,
      success: res => {
        Cookies.set('part_list', res.data.part_list, {
          expires: 365,
          path: '/',
        });
        let successUrl = '/parts-list/';
        // Redirect to part list
        location.replace(successUrl);
      },
    });
  }

  ajaxUpdateCartQty(id, qty) {
    const data = {
      action: 'post_ajax_cart',
      id: id,
      updated_qty: qty,
      update_cart_qty: true,
    };

    $.ajax({
      type: 'POST',
      url: this.url,
      dataType: 'json',
      data: data,
      success: res => {
        Cookies.set('part_list', res.data.part_list, {
          expires: 365,
          path: '/',
        });
        let successUrl = '/parts-list/';
        // Redirect to part list
        location.replace(successUrl);
      },
    });
  }
}

// instantiating cart class
const cart = selector => {
  $(selector).each((index, elem) => {
    new Cart(elem);
  });
};

export default cart;
